module.exports = __webpack_public_path__ + "assets/img/travel-day10.958ad3b9.png";